import { useEffect } from 'react';
import { useApolloClient } from '@apollo/client';
import { clearAuthSessionStorage, setAuthToken } from '@auth/session-storage';
import { useOrganization } from '@providers/organization';
import { OrganizationsListDocument } from '@screens/organizations/organizations.queries.generated';
import { safeRedirectPath } from '@utils/safe-redirect';

export const SupportLogin: React.FunctionComponent = () => {
    const client = useApolloClient();
    const [, setOrganization] = useOrganization();

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const token = params.get('token');
        const redirect = safeRedirectPath(params.get('redirect'));
        clearAuthSessionStorage();
        setAuthToken(token);
        if (!token || redirect === '/') {
            window.location.replace('/');
            return;
        }
        // A deep link skips the dashboard, which is what normally picks the organization, so
        // select the support admin's only organization before the page reloads. Anything else
        // falls back to the dashboard and its organization picker.
        client
            .query({ query: OrganizationsListDocument, fetchPolicy: 'network-only' })
            .then(({ data }) => {
                const organizations = data?.organizations ?? [];
                if (organizations.length === 1 && organizations[0]?.id) {
                    setOrganization(organizations[0].id);
                    return redirect;
                }
                return '/';
            })
            .catch(() => '/')
            .then((target) => window.location.replace(target));
    }, [client, setOrganization]);

    return <></>;
};
